import { useState } from "react";
import { comics, categories } from "@/mocks/home";

const filterTabs = ["全部", ...categories.map((c) => c.name)];

function HotComics() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? comics : comics.filter((c) => c.category === active);

  return (
    <section id="comics" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
              <i className="ri-fire-line"></i>
              热门漫画
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
              追更中的人气作品
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              以下热门漫画均已适配翻页音效与翻页动画，点击即可体验带沉浸声画的纸感阅读。
            </p>
          </div>
        </div>

        <div className="mt-7 flex flex-wrap gap-2">
          {filterTabs.map((tab) => (
            <button
              key={tab}
              type="button"
              onClick={() => setActive(tab)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                active === tab
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-700 hover:bg-secondary-100"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((c) => (
            <article
              key={c.id}
              className="group flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200"
            >
              <div className="relative w-24 shrink-0 overflow-hidden rounded-xl">
                <img
                  src={c.cover}
                  alt={`${c.title}漫画封面`}
                  className="aspect-[5/7] w-full object-cover object-top"
                />
                <span className="absolute left-1.5 top-1.5 rounded-full bg-background-950/60 px-2 py-0.5 text-[10px] text-background-50 backdrop-blur-sm">
                  {c.category}
                </span>
              </div>
              <div className="flex min-w-0 flex-1 flex-col py-1">
                <h3 className="truncate font-medium text-foreground-950">{c.title}</h3>
                <p className="mt-0.5 text-xs text-foreground-500">{c.author}</p>
                <p className="mt-2 flex items-center gap-1 text-xs font-medium text-primary-600">
                  <i className="ri-arrow-right-up-line"></i>
                  {c.chapter}
                </p>
                <p className="mt-auto flex items-center justify-between pt-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {c.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-3-line text-primary-500"></i>
                    {(c.favorite / 10000).toFixed(1)}万
                  </span>
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#category"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-secondary-100"
          >
            浏览全部主题分类
            <i className="ri-arrow-down-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

export default HotComics;